import { render } from "./ResetPasswordModal.vue?vue&type=template&id=561af25c&ts=true"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__